<template>
  <div class="q-dropdown q-position-relative " v-click-outside="closeDropdown" v-if="sortingStore.sort.length > 1">
    <DropdownButton @click="isOpen = !isOpen" :label="sortingStore.getSelectedSortLabelById" :is-open="isOpen"/>
    <ul v-if="isOpen" class="q-dropdown-menu sorting-dropdown__list q-shadow-sm q-rounded-3" :class="computedClass"
        aria-labelledby="sortingDropdown">
      <li v-for="sort in sortingStore.sort" :key="sort.id">
        <a class="q-dropdown-item sorting-dropdown__item" @click="updateSorting(sort)" ><span
            class="sorting-dropdown__label">{{ sort.label }}</span></a>
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import {useSortingStore} from "@/store/SerpPage/SortingStore";
import {computed, defineProps, onMounted, ref} from "vue";
import DropdownButton from '@/components/SerpPage/FiltersContainer/FiltersList/DropdownButton.vue'
import {SortInterface} from "@/core/types";

const sortingStore = useSortingStore();
const isOpen = ref(false);

onMounted(() => {
  sortingStore.fetchSortingOptions()
  sortingStore.syncSelectedSortFromUrl({skipWatcher: true})
})


defineProps(['filterDataValues', 'field'])
function updateSorting(sort: SortInterface) {
  sortingStore.updateSortingOnClick(sort)
  isOpen.value = false
}

function closeDropdown() {
  isOpen.value = false
}

const computedClass = computed(() => {
      const classList = [
        'serp__filter-item--group',
        'q-list-group',
        'q-list-group-flush',
        'q-list-group-collapse',
      ]
      if (isOpen.value) {
        classList.push('q-d-block')
      }
      return classList
    })
;
</script>
<style>
.sorting-dropdown__item{
  cursor: pointer;
}
.q-dropdown-menu {
  position: absolute;
  z-index: 1000;
  display: none;
  min-width: 10em;
  padding: 1em;
  margin: 0;
  font-size: 1em;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 0.25em;
  width: max-content;
  max-width: 300px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;

}

.sorting-buttons {
  cursor: pointer;
}

.q-form-select:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: none !important;
}

.q-dropdown-menu {
  position: absolute;
  z-index: 1000;
  display: none;
  min-width: 10em;
  padding: 0.5em 0;
  margin: 0;
  font-size: 1em;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 0.25em;

}

.q-dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25em 1em;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
</style>